/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateNoteStore } from '../../axios/candidateNoteStore'
import type {
	CandidateNoteStoreError,
	CandidateNoteStorePathParams,
	CandidateNoteStoreRequest,
	CandidateNoteStoreResponse,
} from '../../types/CandidateNoteStore'

export const candidateNoteStoreMutationKey = () => [{ url: '/candidates/:candidate/notes' }] as const

export type CandidateNoteStoreMutationKey = ReturnType<typeof candidateNoteStoreMutationKey>

export type CandidateNoteStoreVariables = {
	candidate: CandidateNoteStorePathParams['candidate']
	data: CandidateNoteStoreRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateNoteController.php CandidateNoteController::store */
export function useCandidateNoteStore<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateNoteStoreResponse,
		AxiosError<CandidateNoteStoreError>,
		CandidateNoteStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateNoteStoreMutationKey(),
		mutationFn: ({ candidate, data }: CandidateNoteStoreVariables) =>
			candidateNoteStore(candidate, data, config).then(res => res.data),
		...options,
	})
}
